<script>
import {CountDown} from "vant";
import moment from "moment";

export default {
  name: "OfflineTime" ,
  props: {
    time: {
      type: String,
      default: 0
    }
  },
  data() {
    return {
      milliseconds: 0,
    }
  },
  mounted() {
    const currentTime = moment();
    const offlineTime = this.time;
    const futureTime = moment(offlineTime, "YYYY-MM-DD HH:mm:ss");
    const duration = moment.duration(futureTime.diff(currentTime));
    // const days = Math.floor(duration.asDays());
    const milliseconds = duration.asMilliseconds()
    if (milliseconds<=0){
      return;
    }
    this.milliseconds = duration.asMilliseconds()
  },
  components: {CountDown}
}
</script>

<template>
<span class="OfflineTime">
  (<CountDown @finish="$emit('ok')" style="position: relative;top: 1px" :time="milliseconds"/>后截止)
</span>
</template>

<style scoped lang="scss">
.OfflineTime{
  position: relative;
  margin-left: 6px;
  bottom: -1px;
  display: flex;
  align-items: center;
  font-size: 14px!important;
  justify-content: center;
}
</style>